<template>
  <Icon :component="WarnSvg" />
</template>

<script lang="ts">
import { defineComponent, markRaw } from 'vue';
import Icon from '@ant-design/icons-vue';
import WarnSvg from './svg/WarnSvg.vue';

export default defineComponent({
  name: 'WarnIcon',
  components: {
    Icon
  },
  props: {},
  data() {
    return {
      WarnSvg: markRaw(WarnSvg)
    };
  }
});
</script>
